var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcSysWarning(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "33px",
    viewBox: "0 0 32 33",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic_sys_warning") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_sys_warning"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.037234, 2.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.8642567,20.4352065 C30.2717354,17.1478139 28.9556452,13.5519653 26.9262828,10.04398 C24.8969205,6.53505987 22.4360378,3.59912008 19.8796778,1.44273259 C17.5985172,-0.480910864 14.3260768,-0.480910864 12.0449163,1.44273259 C9.4885562,3.59912008 7.02860958,6.53505987 5.00018328,10.0430452 C2.97082092,13.5529 1.65379471,17.1478139 1.06127332,20.4361412 C0.533339571,23.3692769 2.16862372,26.1986592 4.97865407,27.2081514 C8.12753551,28.3410259 11.9035723,29 15.962297,29 C20.0219578,29 23.7979946,28.3400912 26.947812,27.2081514 C29.7569063,26.1977245 31.3921905,23.3683422 30.8642567,20.4352065 Z",
    id: "Shape",
    fill: "#F66E20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.962766,9.74339623 C13.962766,8.78113208 14.8583852,8 15.962766,8 C17.0671467,8 17.962766,8.78113208 17.962766,9.74339623 L17.962766,16.2556604 C17.962766,17.2188679 17.0671467,18 15.962766,18 C14.8583852,18 13.962766,17.2188679 13.962766,16.2556604 L13.962766,9.74339623 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.962259,24 C14.8590904,24 13.962766,23.1042354 13.962766,22.0005072 C13.962766,20.8957646 14.8590904,20 15.962259,20 C17.0674554,20 17.962766,20.8957646 17.962766,22.0005072 C17.962766,23.1042354 17.0674554,24 15.962259,24 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSysWarning);
export default __webpack_public_path__ + "static/media/ic_sys_warning.fd66b6a1b75a4ac3a0c636414f7fb574.svg";
export { ForwardRef as ReactComponent };